module.exports = __webpack_public_path__ + "img/404-icon.9516aae8.svg";